import { render, staticRenderFns } from "./sp-editor.vue?vue&type=template&id=013b00da&scoped=true"
import script from "./sp-editor.vue?vue&type=script&lang=js"
export * from "./sp-editor.vue?vue&type=script&lang=js"
import style0 from "./sp-editor.vue?vue&type=style&index=0&id=013b00da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b00da",
  null
  
)

export default component.exports